/// <amd-module name="SuiteCommerce.LookBook.Look"/>
define("SuiteCommerce.LookBook.Look", ["require", "exports", "SuiteCommerce.LookBook.Look.Router"], function (require, exports, Look_Router_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            return new Look_Router_1.LookRouter({
                application: container,
                routes: {},
            });
        },
    };
});
